import { z } from "zod"
import { Locale } from "../employees/response_data"

export const CompanySchema = z.object({
  id: z.bigint(),
  name: z.string(),
  logo: z.string().nullable(),
  slug: z.string().nullable(),
  locale: z.enum(Locale),
  website: z.string().nullable(),
  description: z.string().nullable(),
  products: z.string().nullable(),
  toneOfVoice: z.string().nullable(),
  additionalInfo: z.string().nullable(),
  emailSignature: z.string().nullable(),
  createdAt: z.date().transform((date) => date.toISOString()),
  updatedAt: z.date().transform((date) => date.toISOString()),
})

export const UploadSignatureImageResponseData = z.object({
  url: z.string(),
})
